import actions from "./listingsList.actions";

export const initialState = {
  category: undefined,
  pathLevel: undefined,
  whereFilters: undefined,
  polygon: undefined,
  searchArgQuery: {},
  page: 1,
  lastFindQueryVariables: null,
  // TODO: Move the following state to an independent context
  showUserSidebar: false,
  showServicesPopup: false,
  showSearchBar: false,
};

export const savePolygonMiddleware = (action) => {
  if (action.type === actions.SET_POLYGON) {
    localStorage.setItem("lastPolygon", JSON.stringify(action.payload));
  }
};

export default function listingsListReducer(state, action) {
  switch (action.type) {
    case actions.SET_CATEGORY:
      return {
        ...state,
        category: action.payload.category || initialState.category,
      };
    case actions.SET_PATH_LEVEL:
      return {
        ...state,
        pathLevel: action.payload.pathLevel,
      };
    case actions.SET_WHERE_FILTERS:
      return {
        ...state,
        whereFilters: action.payload || initialState.whereFilters,
      };
    case actions.SET_SEARCH_ARG_QUERY:
      return {
        ...state,
        searchArgQuery: action.payload || initialState.searchArgQuery,
      };
    case actions.SET_PAGE:
      return {
        ...state,
        page: action.payload.page,
      };
    case actions.TOGGLE_USER_SIDEBAR:
      return {
        ...state,
        showUserSidebar: !state.showUserSidebar,
        showServicesPopup: false,
        showSearchBar: false,
      };
    case actions.TOGGLE_SEARCHBAR:
      return {
        ...state,
        showSearchBar:
          action.payload !== undefined ? action.payload : !state.showSearchBar,
        showUserSidebar: false,
        showServicesPopup: false,
      };
    case actions.TOGGLE_SERVICES_POPUP:
      return {
        ...state,
        showUserSidebar: false,
        showServicesPopup: !state.showServicesPopup,
        showSearchBar: false,
      };
    case actions.SET_LAST_FIND_QUERY_VARS:
      return {
        ...state,
        lastFindQueryVariables: action.payload,
      };
    case actions.SET_POLYGON:
      return {
        ...state,
        polygon: [...action.payload],
      };
    default:
      throw new Error("Unsupported action type at listingsList reducer");
  }
}
